import { render, staticRenderFns } from "./LoanPurposePicker.vue?vue&type=template&id=b3eaf50c&scoped=true"
import script from "./LoanPurposePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./LoanPurposePicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LoanPurposePicker.vue?vue&type=style&index=0&id=b3eaf50c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eaf50c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3eaf50c')) {
      api.createRecord('b3eaf50c', component.options)
    } else {
      api.reload('b3eaf50c', component.options)
    }
    module.hot.accept("./LoanPurposePicker.vue?vue&type=template&id=b3eaf50c&scoped=true", function () {
      api.rerender('b3eaf50c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/LoanDetails/components/LoanPurposePicker.vue"
export default component.exports